import moment, { type Moment } from 'moment';
import type { ID } from 'types';
import { DateTimeFormatRepository } from 'consts/general';
import { when } from 'util/support';
import type { UboIdentity } from 'features/ecommerce/types';

export class Identity {
    public readonly fullName: string;
    public readonly dateOfBirth: Moment | null;
    public readonly residentialAddress: string;
    public readonly nationality: string | null;
    public readonly identityFileKey: string | null;
    public readonly addressFileKey: string | null;
    public readonly pki: ID | undefined;
    public readonly legalForm: string | null;

    public constructor({
        fullName = '',
        residentialAddress = '',
        nationality = null,
        identityFileKey = null,
        addressFileKey = null,
        dateOfBirth = null,
        legalForm = null,
        pki
    } = {} as Partial<UboIdentity>) {
        const dateOfBirthInstance = moment(dateOfBirth, DateTimeFormatRepository.Default);

        this.fullName = fullName;
        this.dateOfBirth = when(
            dateOfBirthInstance.isValid(),
            dateOfBirthInstance,
            null
        );
        this.residentialAddress = residentialAddress;
        this.nationality = nationality;
        this.identityFileKey = identityFileKey;
        this.addressFileKey = addressFileKey;
        this.pki = pki;
        this.legalForm = legalForm;
    }
};

export default Identity;
